// Reusable confirmation modal function
function showConfirmation(options) {
    const defaults = {
        title: 'Confirm Action',
        message: 'Are you sure you want to perform this action?',
        confirmText: 'Confirm',
        confirmClass: 'btn-primary',
        cancelText: 'Cancel',
        cancelClass: 'btn-secondary',
        onConfirm: () => {},
        onCancel: () => {}
    };
    const config = { ...defaults, ...options };

    const modalEl = document.getElementById('appConfirmationModal');
    const modal = new bootstrap.Modal(modalEl);
    const titleElement = document.getElementById('confirmationModalLabel');
    const messageElement = document.querySelector('#appConfirmationModal .modal-body');
    const confirmBtn = document.getElementById('confirmBtn');
    const cancelBtn = document.querySelector('#appConfirmationModal .btn-secondary');

    titleElement.textContent = config.title;
    messageElement.innerHTML = config.message;
    confirmBtn.textContent = config.confirmText;
    confirmBtn.className = `btn ${config.confirmClass}`;
    cancelBtn.textContent = config.cancelText;
    cancelBtn.className = `btn ${config.cancelClass}`;

    confirmBtn.onclick = () => {
        modal.hide();
        config.onConfirm();
    };
    cancelBtn.onclick = () => {
        modal.hide();
        config.onCancel();
    };

    // Stack above any already-open modal (Bootstrap doesn't auto-layer nested modals).
    // Count modals open BEFORE we show this one, then bump z-index for the dialog
    // and its backdrop. Cleanup runs on hide.
    const alreadyOpen = document.querySelectorAll('.modal.show').length;
    const stackHandler = () => {
        if (alreadyOpen > 0) {
            const baseZ = 1055 + (alreadyOpen * 20);
            modalEl.style.zIndex = baseZ;
            const backdrops = document.querySelectorAll('.modal-backdrop');
            const topBackdrop = backdrops[backdrops.length - 1];
            if (topBackdrop) {
                topBackdrop.style.zIndex = baseZ - 5;
            }
        }
        modalEl.removeEventListener('shown.bs.modal', stackHandler);
    };
    const cleanupHandler = () => {
        modalEl.style.zIndex = '';
        modalEl.removeEventListener('hidden.bs.modal', cleanupHandler);
    };
    modalEl.addEventListener('shown.bs.modal', stackHandler);
    modalEl.addEventListener('hidden.bs.modal', cleanupHandler);

    modal.show();
}

// Reusable toast function
function showToast(options) {
    const defaults = {
        title: 'Notification',
        message: 'Action completed.',
        type: 'success', // success, error, warning, info
        delay: 3000 // Auto-hide after 3 seconds
    };
    const config = { ...defaults, ...options };

    const toastElement = document.getElementById('appToast');
    // Dispose any prior Bootstrap Toast instance so the new autohide/delay
    // config actually takes effect — getOrCreateInstance reuses old config.
    // delay: 0 means "persist until something else replaces it" (e.g. the
    // "Pushing Invoices…" loader that stays up until success/error toast).
    const prior = bootstrap.Toast.getInstance(toastElement);
    if (prior) {
        prior.dispose();
    }
    const toast = new bootstrap.Toast(toastElement, {
        autohide: config.delay > 0,
        delay: config.delay > 0 ? config.delay : 5000
    });
    const titleElement = document.getElementById('toastTitle');
    const messageElement = document.getElementById('toastMessage');

    titleElement.textContent = config.title;
    messageElement.innerHTML = config.message;
    toastElement.classList.remove('bg-success', 'bg-danger', 'bg-warning', 'bg-info');
    toastElement.classList.add(`bg-${config.type}`);

    toast.show();
}